module.exports = __webpack_public_path__ + "img/new_04.4f6fcb9d.jpg";